import React from 'react';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { Redirect } from "react-router-dom";

export default function NotFound(props)
{
    if (props.user)
    {
        return(
            <Redirect
            to={{
            pathname: "/dashboard"}}/>
            );
    } else 
    {
        return(
            <Redirect
            to={{
            pathname: "/login"}}/>
            );
    }
}